<template>
  <div v-if="isMain && userDetail">
    <div>
      <header>
        {{ userDetail.display_name }}
        <div class="h-left">
          <a
            @click="
              $router.go(-1);
              setFooter(true);
            "
            ><img src="~@/assets/images/icon02.svg"
          /></a>
        </div>
      </header>
      <div id="wrap">
        <div id="fbt">
          <div class="fbt">
            <a>
              <div :class="isSubmit ? 'fbt02' : 'btn-disable'" @click="submit">
                <img src="~@/assets/images/fbt-iocn09.svg" />
              </div>
            </a>
          </div>
        </div>

        <div class="txt-area" style="padding-top: 0">
          <div class="btn5">
            <a
              @click="
                $router.push({ name: 'showInfoProfile' });
                setFooter(false);
              "
              >お相手から見たプロフィールを表示</a
            >
          </div>
        </div>

        <div class="search-form-title">プロフィール編集</div>
        <div class="txt-area">
          <p>自分の魅力が一番伝わる写真を選びましょう。</p>
          <div class="btn5">
            <a @click="isShowPhotoModal = true">写真の選び方についてみる</a>
          </div>
        </div>

        <div class="mypage-edit01" style="padding: 0">
          <div class="main_avatar">
            <img
              @click="openShowUploadImageMain"
              id="main_avatar"
              v-if="
                (!userDetail.avatar_url ||
                  userDetail.avatar_url.includes(URL_DEFAULT)) &&
                parseInt(userDetail.sex) === MALE
              "
              src="~@/assets/images/profile_man_p.png"
            />
            <img
              @click="openShowUploadImageMain"
              id="main_avatar"
              v-if="
                (!userDetail.avatar_url ||
                  userDetail.avatar_url.includes(URL_DEFAULT)) &&
                parseInt(userDetail.sex) === FEMALE
              "
              src="~@/assets/images/profile_woman_p.png"
            />
            <div v-if="checkApproveAvatar(userDetail.avatar_url)" @click="isShowTypeMatching = true; isEditMainAvatar = true; selectedImgIndex = userDetail.image[0].image_index">
              <img
                id="main_avatar"
                v-if="
                  userDetail.avatar_url &&
                  !userDetail.avatar_url.includes(URL_DEFAULT)
                "
                :src="getImageUrl(userDetail.avatar_url)"
              />
            </div>
            <div v-else @click="isShowSuccessDialog = true; successDialogMsg = '現在、審査中です。';">
              <img
                id="main_avatar"
                v-if="
                  userDetail.avatar_url &&
                  !userDetail.avatar_url.includes(URL_DEFAULT)
                "
                :src="getImageUrl(userDetail.avatar_url)"
              />
              <div class="blurA">
                審査中
              </div>
            </div>
          </div>
        </div>
        <ul class="prof-ph02 clearfix" id="list_image">
          <li
            class="parent_avatar"
            v-for="(item, index) in getImage(userDetail.image)"
            :key="index"
          >
            <div v-if="checkApproveAvatar(item.path)" @click="setSelectedAvatar($event); isShowTypeMatching = true; isEditSubAvatar = true; selectedImgIndex = item.image_index">
              <img :src="getImageUrl(item.path)" />
            </div>
            <div v-else @click="isShowSuccessDialog = true; successDialogMsg = '現在、審査中です。';">
              <img :src="getImageUrl(item.path)" />
              <div class="blurA" v-if="!checkApproveAvatar(item.path)">
                審査中
              </div>
            </div>
            
          </li>
          <li
            class="parent_avatar"
            v-if="
              indexPreviewImage < 5 && getImage(userDetail.image).length <= 4
            "
            id="addNew"
            @click="openShowUploadImage"
          >
            <img src="~@/assets/images/ph-select.png" />
          </li>
        </ul>

        <div class="search-form-title">ひとこと</div>
        <div class="txt-area" style="padding-top: 0">
          <div class="btn6">
            <a
              @click="
                isMain = false;
                isUploadMoodStatus = true;
              "
              >{{
                userDetail.mood_status_tmp ? userDetail.mood_status_tmp : ""
              }}</a
            >
          </div>
        </div>

        <div class="search-form-title">自己紹介</div>
        <div class="txt-area" style="padding-top: 0">
          <div class="btn6">
            <a
              @click="
                isMain = false;
                isUpdateStatus = true;
              "
            >
              {{ userDetail.user_status ? userDetail.user_status : "" }}
            </a>
          </div>
        </div>
        <data-search
          @setData="getFormDataSearch"
          :userDetail="userDetail"
          @closeMain="closeMainSearch"
        ></data-search>
      </div>
      <nav v-if="isShowPhotoModal">
        <div id="modal">
          <div class="modal">
            <p><img src="~@/assets/images/pop-ph.jpg" /></p>
            <div class="btn1"><a @click="closeModalPhoto">OK</a></div>
          </div>
        </div>
      </nav>
      <div @click="isShowChooseTypeImage = false; isChooseImage = false;">
        <basicDialog :active="isShowChooseTypeImage">
        <div class="flex-row">
          <button class="btn-start" @click="openCamera">カメラから</button>
          <button class="btn-end" @click="openFile">ギャラリーから</button>
          <button
            class="btn-close"
            @click="
              isShowChooseTypeImage = false;
              isChooseImage = false;
            "
          >
            キャンセル
          </button>
          <input type="file" name="fileImage" hidden />
        </div>
        </basicDialog>
      </div>
      <div @click="closeChooseType('out')">
        <basicDialog :active="isShowTypeMatching">
          <div class="flex-row">
            <button v-if="isEditSubAvatar" class="sub-avatar-edit-title">
              サブ写真の編集
            </button>
            <button v-if="isEditMainAvatar" class="btn-chg-to-main" @click="openShowUploadImageMain()">
              変更する
            </button>
            <button v-if="isEditSubAvatar" class="btn-chg-to-main"
              @click="isConfirmEditAvatar = true;
                      confirmEditAvatarMsg = 'この写真とメインアバターを入れ替えます。よろしいですか？';
                      isChangeMainAvatar = true;
                     "
            >
              メイン写真にする
            </button>
            <button v-if="isEditSubAvatar || isUploadSubAvatar" class="btn-start" @click="chooseType(VIEW_STATUS_AVATAR_ALL)">
              <span>✅</span>
              <span>全会員に表示</span>
            </button>
            <button
              v-if="isEditSubAvatar || isUploadSubAvatar"
              class="btn-start-1"
              @click="chooseType(VIEW_STATUS_AVATAR_LIKE)"
            >
              いいねしたお相手のみに表示
            </button>
            <button
              v-if="isEditSubAvatar || isUploadSubAvatar"
              class="btn-end"
              @click="chooseType(VIEW_STATUS_AVATAR_MATCHING)"
            >
              マッチングしたお相手のみに表示
            </button>
            <button v-if="isEditSubAvatar || isEditMainAvatar" style="color: red" class="btn-del-sub-avatar" @click="deleteAvatar()">
              削除
            </button>
            <button class="btn-close" @click="closeChooseType('in')">
              キャンセル
            </button>
          </div>
        </basicDialog>
      </div>
      <div @click="isConfirmEditAvatar = false">
        <basicDialog :active="isConfirmEditAvatar">
          <div class="flex-row">
            <div class="confirm-edit-avatar-mgs">{{ confirmEditAvatarMsg }}</div>
            <div class="confirm-edit-avatar-btn">
              <button class="btn_cancel"
                @click="isConfirmEditAvatar = false;"
              >
                キャンセル
              </button>
              <button
                @click="confirmEditAvatar()"
              >
                確認する
              </button>
            </div>
            
          </div>
        </basicDialog>
      </div>
    </div>
    <!-- <input type="file" accept="image/*" id="camera" capture="camera" hidden />
    <input type="file" accept="image/*" id="image" hidden /> -->
    <!-- <img id="output" /> -->
  </div>
  <div v-else>
    <editMoodStatus
      :isShow="isUploadMoodStatus"
      @close="closeUploadMoodStatus"
      @submit="submitMoodStatus"
      :value="userDetail.mood_status_tmp"
    ></editMoodStatus>
    <editStatus
      :isShow="isUpdateStatus"
      @close="closeStatus"
      @submit="submitStatus"
      :value="userDetail.user_status"
    ></editStatus>
    <editHobby
      :is-show="isHobby"
      :value="userDetail.hobby"
      @submit="submitHobby"
      @close="
        isMain = true;
        isHobby = false;
      "
    ></editHobby>
    <editFavoritePace
      :is-show="isFavorite"
      :value="userDetail.favorite_place"
      @submit="submitFavorite"
      @close="
        isMain = true;
        isFavorite = false;
      "
    ></editFavoritePace>
    <editFirstPlace
      :is-show="isFirstPlace"
      :value="userDetail.first_place"
      @submit="submitFirstPlace"
      @close="
        isMain = true;
        isFirstPlace = false;
      "
    ></editFirstPlace>
  </div>
  <!-- <basicDialog :active="isAlert">
    <div class="message">
      プロフィールを更新しました。
    </div>
  </basicDialog> -->
<div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
</div>

<div @click="closeAlert()">
  <successDialog :active="isShowSuccessDialog" @close="closeAlert">
    <!-- <template v-slot:title>
    </template> -->
    <template v-slot:message>
      <p>{{ successDialogMsg }}</p>
    </template>
    <!-- <p>
      
    </p> -->
  </successDialog>
</div>
<alertDialogBottom :active="isAlert">
     プロフィールを更新しました。
</alertDialogBottom>
<alertDialogBottom :active="isShowSuccessBottomDialog">
     {{ successDialogMsg }}
</alertDialogBottom>
</template>

<script>

import basicDialog from "./components/basicDialog";
import { mapGetters, mapActions } from "vuex";
import CONSTANTS from "@/constants";
import editMoodStatus from "./components/editMoodStatus";
import editStatus from "./components/editStatus";
import dataSearch from "./components/dataSearch";
import editHobby from "./components/editHobby";
import editFavoritePace from "./components/editFavoritePace";
import editFirstPlace from "./components/editFirstPlace";
import mixin from "@/mixin";
import successDialog from "@/views/components/successDialog";
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
export default {
  components: {
    basicDialog,
    editMoodStatus,
    editStatus,
    dataSearch,
    editHobby,
    editFavoritePace,
    editFirstPlace,
    successDialog,
    alertDialogBottom
  },
  mixins: [mixin],
  data: () => ({
    isShowPhotoModal: false,
    isChooseImage: false,
    isShowChooseTypeImage: false,
    isUpdateStatus: false,
    picture: null,
    VIEW_STATUS_AVATAR_ALL: CONSTANTS.VIEW_STATUS_AVATAR_ALL,
    VIEW_STATUS_AVATAR_LIKE: CONSTANTS.VIEW_STATUS_AVATAR_LIKE,
    VIEW_STATUS_AVATAR_MATCHING: CONSTANTS.VIEW_STATUS_AVATAR_MATCHING,
    isShowTypeMatching: false,
    file: null,
    viewStatus: 1,
    indexPreviewImage: 0,
    fileList: [],
    isSubmit: false,
    index: 0,
    isMain: true,
    isUploadMoodStatus: false,
    formData: {
      style: null,
      birth_place: null,
      roommate: null,
      child: null,
      education: null,
      job: null,
      income: null,
      holidays: null,
      drinking: null,
      smoking: null,
      hobby: null,
      favorite_place: null,
      first_place: null,
      meeting_condition: null,
      purpose: null,
      height: null,
      mood_status: null,
      user_status: null,
    },
    DEFAULT_VALUE: CONSTANTS.DEFAULT_VALUE,
    isHobby: false,
    isFavorite: false,
    isFirstPlace: false,
    IS_APPROVE: CONSTANTS.IS_APPROVE,
    URL_DEFAULT: CONSTANTS.URL_DEFAULT,
    fileMainAvatar: null,
    isMainUpload: false,
    isUpload: false,
    MALE: CONSTANTS.MALE,
    FEMALE: CONSTANTS.FEMALE,
    fileTemp: null,
    fileSrc: null,
    idImage: 1,
    isAlert: false,
    scrollPosition: 0,
    isShowSuccessDialog: false,
    isEditMainAvatar: false,
    isEditSubAvatar: false,
    isUploadSubAvatar: false,
    isLoading: false,
    selectedImgIndex: -1,
    successDialogMsg: '',
    selectedAvatar: '',
    isConfirmEditAvatar: false,
    confirmEditAvatarMsg: '',
    isChangeMainAvatar: false,
    camera: null,
    image: null,
    viewStatusList: [],
    isShowSuccessBottomDialog: false
  }),
  mounted() {
    if (this.getImage(this.userDetail.image).length > 0) {
      this.indexPreviewImage = this.getImage(this.userDetail.image).length;
      this.index = this.indexPreviewImage
    }
    this.setEventInputImage()
  },

  watch: {
    isMain(val) {
      if (!val) {
        this.setScrollPosition();
        window.scrollTo(0, 0);
      }
      else this.scrollToPosition();
    }
  },
  computed: {
    ...mapGetters(["metadata", "defaultToken", "userDetail"]),
  },
  methods: {
    ...mapActions({
      userProfile: "user/userProfile",
      getDefaultToken: "user/getDefaultToken",
      setFooter: "layout/setFooter",
    }),
    openShowUploadImageMain() {
      if (
        this.isUpload ||
        !this.checkApproveAvatar(this.userDetail.avatar_url)
      ) {
        return;
      }
      this.isShowPhotoModal = true;
      this.isChooseImage = true;
      this.isMainUpload = true;
    },
    closeChooseType(type) {
      this.resetChooseType();
      this.file = null;
      if (type == 'in') {
        this.fileList.splice(this.fileList.length - 1, 1);
      }
      // this.fileMainAvatar = null;
    },
    resetChooseType() {
      this.isShowTypeMatching = false;
      this.isEditSubAvatar = false;
      this.isEditMainAvatar = false;
      this.isUploadSubAvatar = false;
    },
    closeMainSearch(key) {
      this.isMain = false;
      if (key === "hobby") {
        this.isHobby = true;
        this.isFavorite = false;
        this.isFirstPlace = false;
      }
      if (key === "favorite") {
        this.isFavorite = true;
        this.isHobby = false;
        this.isFirstPlace = false;
      }
      if (key === "firstPlace") {
        this.isFirstPlace = true;
        this.isHobby = false;
        this.isFavorite = false;
      }
    },
    submitHobby(value) {
      this.formData.hobby = value;
      this.userDetail.hobby = value;
      this.isMain = true;
      this.isHobby = false;
      this.isSubmit = true;
    },
    submitFavorite(value) {
      this.formData.favorite_place = value;
      this.userDetail.favorite_place = value;
      this.isMain = true;
      this.isFavorite = false;
      this.isSubmit = true;
    },
    submitFirstPlace(value) {
      this.formData.first_place = value;
      this.userDetail.first_place = value;
      this.isMain = true;
      this.isFirstPlace = false;
      this.isSubmit = true;
    },
    setDataSearch(formData) {
      let asArray = Object.entries(formData);
      formData = asArray.filter((item) => {
        return (
          item[1] !== CONSTANTS.DEFAULT_VALUE &&
          item[1] !== null &&
          item[1] !== ""
        );
      });
      formData = Object.fromEntries(formData);
      return formData;
    },
    getFormDataSearch(formData) {
      this.isSubmit = true;
      this.formData = Object.assign(
        this.formData,
        this.setDataSearch(formData)
      );
    },
    closeUploadMoodStatus() {
      this.isUploadMoodStatus = false;
      this.isMain = true;
    },
    closeStatus() {
      this.isUpdateStatus = false;
      this.isMain = true;
    },
    submitMoodStatus(formData) {
      this.userDetail.mood_status_tmp = formData.mood_status;
      this.isUploadMoodStatus = false;
      this.isMain = true;
      this.formData = Object.assign(this.formData, formData);
      // console.log("formdata: ", formData);
      this.isSubmit = true;
    },
    submitStatus(formData) {
      this.userDetail.user_status = formData.user_status;
      this.isUpdateStatus = false;
      this.isMain = true;
      this.formData = Object.assign(this.formData, formData);
      // console.log("formdata: ", this.formData);
      this.isSubmit = true;
    },
    getImage(images) {
      if (images) {
        let imgs = JSON.parse(images);
        // console.log("imgs: ", imgs);
        imgs.splice(0, 1);
        if (imgs[0]) {
          imgs = imgs.filter((item) => {
            return (
              (parseInt(item.is_approve) === CONSTANTS.IS_APPROVE ||
                parseInt(item.is_approve) === CONSTANTS.PC_APPROVE) &&
              !item.path.includes(CONSTANTS.URL_DEFAULT)
            );
            // && item.default != 0;
          });
        }
        // console.log('get index: ', this.index)
        return imgs;
      }
    },
    openShowUploadImage() {
      this.isShowPhotoModal = true;
      this.isChooseImage = true;
      this.isMainUpload = false;
    },
    closeModalPhoto() {
      this.isShowPhotoModal = false;
      if (this.isChooseImage) {
        this.isShowChooseTypeImage = true;
      }
    },
    openCamera() {
      this.beforeOpenFile();
      // let camera = document.getElementById("camera");
      // console.log(this.userDetail);
      this.camera.click();
    },
    openFile() {
      this.beforeOpenFile();
      // let image = document.getElementById("image");
      // console.log(this.userDetail);
      this.image.click();
    },
    beforeOpenFile() {
      this.isShowPhotoModal = false;
      this.isChooseImage = false;
      this.isShowChooseTypeImage = false;
      this.isUploadSubAvatar = true;
    },
    chooseType(viewStatus) {
      this.viewStatus = viewStatus;
      this.viewStatusList.push(viewStatus);
      // Edit sub avatar
      if (this.isEditSubAvatar) {
        this.isConfirmEditAvatar = true;
        if (viewStatus == 0) {
          this.confirmEditAvatarMsg = '画像は全てのユーザーに公開されます。';

        } else if (viewStatus == 1) {
          this.confirmEditAvatarMsg = '画像はいいね！を送ったお相手のみに表示されます。';

        } else if (viewStatus == 2) {
          this.confirmEditAvatarMsg = '画像はマッチングしているお相手のみに表示されます。';
        }

      // Upload sub avatar
      } else {
        this.reviewSubAvatar()
        this.indexPreviewImage++;

        this.isShowTypeMatching = false;
        this.isSubmit = true;
        this.isMainUpload = false;
      }
    },
    async submit() {
      if (!this.isSubmit) {
        return
      } else {
        this.isLoading = true;
        this.isSubmit = false;
        // console.log('file upload:::', this.fileList[0]);
        // this.isLoading = false;
        // return;
        this.uploadAvatar()
        if (this.fileList[0]) {
          
          for (let i = 0; i < this.fileList.length; i++) {
            this.index ++
            await this.downscaleImage(this.fileList[i]).then(async file => {
              let formData = new FormData();
              formData.append("token", this.defaultToken);
              formData.append("is_main", 0);
              formData.append("images[" + (this.index) + "]", file);
              formData.append("view_status", this.viewStatusList[i]);
              await this.$store.dispatch("profile/uploadFileImages", formData)
                .then((data) => {
                  this.isAlert = true
                  setTimeout(() => {
                    this.isAlert = false
                  }, 1000)
                })
                .catch((err) => {
                  this.isLoading = false;
                  console.log(err);
              });
            });
          }
          this.showApproveSubAvatar()
        }
        this.fileList = [];
        this.file = null;
        this.formData = this.setDataSearch(this.formData);
        if (this.formData != {}) {
          let formData = new FormData();
          formData.append("token", this.defaultToken);
          let asArray = Object.entries(this.formData);
          asArray.forEach((item) => {
            formData.append(item[0], item[1]);
          });
          await this.$store
            .dispatch("user/userUpdate", formData)
            .then((data) => {
              this.isLoading = false;
              this.isAlert = true
              setTimeout(() => {
                this.isAlert = false
              }, 1000)
            })
            .catch((err) => {
              this.isLoading = false;
              console.log(err);
            });

        }
      }
    },

    checkApproveAvatar(image) {
      if (image.includes(CONSTANTS.URL_TEMP_AVATAR)) return false;
      return true;
    },

    async uploadAvatar() {
      if (this.fileMainAvatar) {
        let formData = new FormData();
        formData.append("token", this.defaultToken);
        formData.append("is_main", 1);
        // formData.append("view_status", this.viewStatus);
        await this.downscaleImage(this.fileMainAvatar).then(file => {
          formData.append("images[0]", file);
        });
        this.isUpload = true;
        await this.$store
          .dispatch("profile/uploadFileImages", formData)
          .then((data) => {
            this.showApproveAvatar();
            this.isAlert = true
            setTimeout(() => {
              this.isAlert = false
            }, 1000)
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    reviewAvatar() {
      document.getElementById("main_avatar").src = URL.createObjectURL(
        this.file
      );
      
    },
    showApproveAvatar() {
      let parent = document.getElementsByClassName("main_avatar")[0];
      let div = document.createElement("div");
      div.innerText = "審査中";
      div.style.position = "absolute";
      div.style.top = 0;
      div.style.bottom = 0;
      div.style.left = 0;
      div.style.right = 0;
      div.style.background = "#2c2c2c87";
      div.style.height = "100%";
      div.style.width = "100%";
      div.style.zIndex = "9999";
      div.style.display = "flex";
      div.style.justifyContent = "center";
      div.style.alignItems = "center";
      div.style.color = "#fff";
      parent.appendChild(div);
    },
    reviewSubAvatar() {
      let p = document.createElement("li");
      let img = document.createElement("img");
      // p.style.width = "100%";
      p.style.height = "100%";
      p.style.padding = 0;
      p.className = "parent_avatar";
      p.id = this.idImage
      this.idImage ++
      img.style.height = "100%";
      img.src = URL.createObjectURL(this.file);
      img.onload = function () {
        URL.revokeObjectURL(img.src);
      };
      p.appendChild(img);
      let parent = document.getElementById("list_image");
      parent.insertBefore(p, document.getElementById("addNew"));
    },
    showApproveSubAvatar() {
      for(let i = 1; i <= this.idImage; i ++) {
        if (document.getElementById(i)) {
          document.getElementById(i).appendChild(this.createDiv())
        }
      }
    },
    createDiv() {
      let div = document.createElement("div");
      div.innerText = "審査中";
      div.style.position = "absolute";
      div.style.top = 0;
      div.style.bottom = 0;
      div.style.left = 0;
      div.style.right = 0;
      div.style.background = "#2c2c2c87";
      div.style.height = "100%";
      div.style.width = "100%";
      div.style.zIndex = "9999";
      div.style.display = "flex";
      div.style.justifyContent = "center";
      div.style.alignItems = "center";
      div.style.color = "#fff";
      return div
    },
    setEventInputImage() {
      this.camera = document.createElement('input')
      this.camera.setAttribute('accept', 'image/*')
      this.camera.setAttribute('capture', 'camera')
      this.camera.setAttribute('type', 'file')
      this.camera.setAttribute('hidden', true)
      this.image = document.createElement('input')
      this.image.setAttribute('accept', 'image/*')
      // image.setAttribute('capture', 'environment')
      this.image.setAttribute('type', 'file')
      this.image.setAttribute('hidden', true)
      // let camera = document.querySelector("#camera");
      // console.log(camera)
      this.camera.addEventListener("change", (e) => {
        console.log(e)
        e.preventDefault()
        this.file = this.camera.files[0];
        // console.log('file: ', this.file)
        if (this.isMainUpload) {
          this.fileMainAvatar = this.camera.files[0];
          this.reviewAvatar()
          this.isSubmit = true
          this.resetChooseType()
          // await this.submit()
          // await this.uploadAvatar();
        } else {
          this.fileList.push(this.camera.files[0]);
          this.isShowTypeMatching = true;
        }
      });
      // 
      // let image = document.querySelector("#image");
      // console.log(this.userDetail);
      this.image.addEventListener("change", (e) => {
        e.preventDefault()
        this.file = this.image.files[0];
        if (this.isMainUpload) {
          this.fileMainAvatar = this.image.files[0];
          this.reviewAvatar()
          this.isSubmit = true
          this.resetChooseType()
          // await this.submit()
        } else {
          this.fileList.push(this.image.files[0]);
          this.isShowTypeMatching = true;
        }
      });
    },
    updateIndexSubAvatar() {
      this.index ++
    },
    setScrollPosition() {
      this.scrollPosition = window.scrollY;
    },
    scrollToPosition() {
        setTimeout(() => {
            window.scrollTo(0, this.scrollPosition)
        }, 10);
    },
    closeAlert() {
      this.isShowSuccessDialog = false
    },
    async deleteAvatar() {
      this.isLoading = true;
      // Vì isEditMainAvatar bị reset nên dùng biến tempIsEditMainAvatar để lưu
      let tempIsEditMainAvatar = this.isEditMainAvatar;

      if (this.selectedImgIndex != -1) {
        let formData = new FormData();
        formData.append("token", this.defaultToken);
        formData.append("index", this.selectedImgIndex);
        await this.$store
          .dispatch("profile/deleteAvatar", formData)
          .then((data) => {
            this.isShowSuccessBottomDialog = true;
            this.successDialogMsg = 'アバターを削除しました。';
            setTimeout(() => {
                this.isShowSuccessBottomDialog = false
            }, 1000)

            if (tempIsEditMainAvatar) {
              this.userDetail.avatar_url = this.URL_DEFAULT;

            } else {
              this.selectedAvatar.remove();
              this.selectedAvatar = '';
            }

            this.isLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.isLoading = false;
          });
      }
    },
    setSelectedAvatar(e) {
      this.selectedAvatar = e.target.parentElement.parentElement;
    },
    async confirmEditAvatar() {
      this.isLoading = true;
      if (this.isChangeMainAvatar) {
        this.changeMainAvatar();
        this.isChangeMainAvatar = false;

      } else {
        let formData = new FormData();
        formData.append("index", this.selectedImgIndex);
        formData.append("view_status", this.viewStatus);
        formData.append("token", this.defaultToken);

        await this.$store
          .dispatch("profile/updateImageStatus", formData)
          .then((data) => {
            this.isEditSubAvatar = false;
            this.isShowSuccessBottomDialog = true;
            this.successDialogMsg = 'プロフィールを更新しました。';
            setTimeout(() => {
                this.isShowSuccessBottomDialog = false
            }, 1000)
            this.isLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.isEditSubAvatar = false;
            this.isLoading = false;
          });
      }
    },
    async changeMainAvatar() {
      let formData = new FormData();
      formData.append("index", this.selectedImgIndex);
      formData.append("is_main", 1); // 1: main avatar, 0: not main avatar
      formData.append("token", this.defaultToken);

      await this.$store
        .dispatch("profile/updateImageStatus", formData)
        .then((data) => {
          this.isEditSubAvatar = false;
          this.isShowSuccessBottomDialog = true;
          this.successDialogMsg = 'プロフィールを更新しました。';
          setTimeout(() => {
              this.isShowSuccessBottomDialog = false
          }, 1000)

          // Get main avatar
          let main_avatar = document.getElementById('main_avatar').src;
          // Get sub avatar
          let sub_avatar = this.selectedAvatar.getElementsByTagName('img')[0].src;
          // Change src sub avatar and main avatar
          document.getElementById('main_avatar').src = sub_avatar;
          this.selectedAvatar.getElementsByTagName('img')[0].src = main_avatar;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isEditSubAvatar = false;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="css" scoped>
.flex-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-row button {
  outline: none;
  border: none;
  color: #4a87fb;
  width: 100%;
  background: #fff;
  padding: 10px;
    border-bottom: 1px solid rgb(160, 160, 160);
}

.flex-row button.btn-start {

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.flex-row button.btn-end {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.flex-row button.btn-close {
  margin-top: 15px;
  border-radius: 5px;
}

.flex-row button.sub-avatar-edit-title {
  color: grey;
  font-size: 11px;
}

.btn-disable {
  height: 60px;
  width: 60px;
  background: linear-gradient(
    to right,
    rgb(161, 161, 161) 0%,
    rgb(133, 133, 133) 100%
  );
  text-align: center;
  font-weight: bold;
  border-radius: 100%;
  position: absolute;
  bottom: 10px;
  right: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 8px gray;
}

.parent_avatar {
  /* width: 100%; */
  height: 100%;
  padding: 0 !important;
}

.parent_avatar div {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2c2c2c87;
  height: 100%;
  width: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.parent_avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#list_image {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 3px;
  padding: 16px 3%;
}

/* avatar */
.main_avatar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main_avatar .blurA {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00000066;
  color: #fff;
}

.main_avatar img {
  /* width: 60vw;
  height: 60vw; */
  /* max-height: 500px; */
  width: 100%;
  max-width: 440px;
  height: 384px;
  object-fit: cover;
}
#list_image {
    height: 26vw;
    max-height: 120px;
    display: flex
}
.message {
    color: #00000026;
    background: #fff;
    border-radius: 5px;
    padding: 5px;
}

.loading-screen {
    background: #00000026;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader {
    display: inline-block;
    margin: 5px 0;
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 28px;
    border-radius: 50%;
    border: 2px solid #fff;
    border-right-color: transparent;
    -webkit-animation: spin 1s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
}

.confirm-edit-avatar-mgs {
    outline: none;
    border: none;
    width: -webkit-fill-available;
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid rgb(160, 160, 160);
}

.confirm-edit-avatar-btn {
  width: -webkit-fill-available;
}

.confirm-edit-avatar-btn button {
  width: 50%;
}

.confirm-edit-avatar-btn .btn_cancel {
  border-right: 1px solid rgb(160, 160, 160);
}
</style>
